import { IconBrandX } from '@tabler/icons-react'
import { ArrowRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import { FooterGlobe } from './FooterGlobe'
import { config } from '../../../config'
import { MARKETING_ROUTES, getLocalizedRoute } from '@/lib/marketingRoutes'
import '@/pages/Landing.css'

export function LandingFooter({ fr }: { fr: boolean }) {
	const home = fr ? MARKETING_ROUTES.home.fr : MARKETING_ROUTES.home.en

	const columns = [
		{
			title: fr ? 'Produit' : 'Product',
			links: [
				{ label: fr ? 'Widget site web' : 'Website feedback widget', href: getLocalizedRoute('websiteFeedbackWidget', fr) },
				{ label: fr ? 'Widget in-app' : 'In-app feedback widget', href: getLocalizedRoute('inAppFeedbackWidget', fr) },
				{ label: fr ? 'Votes & idées' : 'Feature voting tool', href: getLocalizedRoute('featureVotingTool', fr) },
				{ label: fr ? 'Roadmap publique' : 'Public roadmap', href: getLocalizedRoute('publicRoadmapSoftware', fr) },
			],
		},
		{
			title: fr ? 'Ressources' : 'Resources',
			links: [
				{ label: 'Docs', href: '/docs' },
				{ label: 'Blog', href: '/blog' },
				{ label: fr ? 'Notre roadmap' : 'Our roadmap', href: 'https://feedbask-roadmap.feedbask.com/' },
				{ label: 'Alternatives', href: getLocalizedRoute('alternatives', fr) },
				{ label: fr ? 'Comparaisons' : 'Compare', href: getLocalizedRoute('compare', fr) },
				{ label: fr ? 'Équipe' : 'Team', href: '/team' },
			],
		},
		{
			title: fr ? 'Légal' : 'Legal',
			links: [
				{ label: fr ? 'Confidentialité' : 'Privacy policy', href: '/privacy' },
				{ label: fr ? 'Conditions' : 'Terms of service', href: '/tos' },
				{ label: fr ? 'Mentions légales' : 'Legal notice', href: fr ? '/mentions-legales' : '/legal' },
				{ label: 'Cookies', href: '/cookies' },
				{ label: 'Contact', href: `mailto:${config.supportEmail}` },
			],
		},
		{
			title: fr ? 'Vous pourriez aussi aimer' : 'You might also like',
			links: [
				{ label: 'Murmur', href: 'https://www.murmurtts.com/' },
				{ label: 'Refindie', href: 'https://refindie.com/' },
				{ label: 'Rocket MVP', href: 'https://www.rocketmvp.io/' },
			],
		},
	]

	return (
		<footer className="fb-footer">
			<div className="fb-container">
				<div className="fb-footer-card">
					<div className="fb-footer-cta">
						<div className="fb-footer-cta-copy">
							<h3>
								{fr ? 'Tous vos retours,' : 'Every piece of feedback,'}
								<br />
								<em>{fr ? 'au même endroit.' : 'in one place.'}</em>
							</h3>
							<p>
								{fr
									? 'Un seul widget pour les bugs, les idées, les avis et les notes, avec le contexte derrière chacun.'
									: 'One widget for bug reports, ideas, reviews, and ratings, with the context behind each one.'}
							</p>
							<Link to="/auth" className="fb-button">
								{fr ? 'Commencer gratuitement' : 'Start for free'} <ArrowRight size={16} />
							</Link>
						</div>
						<div className="fb-footer-globe" aria-hidden="true">
							<FooterGlobe />
						</div>
					</div>

					<div className="fb-footer-grid">
						<div className="fb-footer-brand">
							<Link to={home} className="fb-footer-logo">
								<img src={config.logo} alt="Feedbask" width="146" height="44" />
							</Link>
							<p>
								{fr
									? 'Feedbask aide les petites équipes produit à recueillir les retours, corriger ce qui ne va pas et livrer ce que leurs clients demandent vraiment.'
									: "Feedbask helps small product teams collect feedback, fix what's broken, and ship what customers actually ask for."}
							</p>
							<a href={`mailto:${config.supportEmail}`}>{config.supportEmail}</a>
							<a
								className="fb-footer-social"
								href="https://x.com/feedbask_com"
								target="_blank"
								rel="noopener noreferrer"
								aria-label="Feedbask on X"
							>
								<IconBrandX size={15} aria-hidden="true" /> @feedbask_com
							</a>
						</div>
						<nav className="fb-footer-nav" aria-label={fr ? 'Liens de pied de page' : 'Footer links'}>
							{columns.map((column) => (
								<div className="fb-footer-col" key={column.title}>
									<h4>{column.title}</h4>
									<ul>
										{column.links.map((link) => (
											<li key={link.label}>
												{link.href.startsWith('http') || link.href.startsWith('mailto:') ? (
													<a href={link.href} target={link.href.startsWith('http') ? '_blank' : undefined} rel={link.href.startsWith('http') ? 'noopener noreferrer' : undefined}>
														{link.label}
													</a>
												) : (
													<Link to={link.href}>{link.label}</Link>
												)}
											</li>
										))}
									</ul>
								</div>
							))}
						</nav>
					</div>

					<div className="fb-footer-bottom">
						<span>
							© {new Date().getFullYear()} Feedbask
						</span>
						<span>{fr ? 'Fait pour les petites équipes produit.' : 'Made for small product teams.'}</span>
					</div>
				</div>
			</div>
		</footer>
	)
}
